export const PIANO_WHITE_NOTES = ["C", "D", "E", "F", "G", "A", "B"];
export const PIANO_BLACK_NOTES = ["C#", "D#", "F#", "G#", "A#"];

const BLACK_KEY_AFTER_WHITE_INDEX = {
  C: 0,
  D: 1,
  F: 3,
  G: 4,
  A: 5,
};

export const buildPianoKeys = ({ startOctave = 3, octaves = 2 } = {}) => {
  const whiteKeys = [];
  const blackKeys = [];

  for (let octaveOffset = 0; octaveOffset < octaves; octaveOffset += 1) {
    const octave = startOctave + octaveOffset;

    PIANO_WHITE_NOTES.forEach((note) => {
      whiteKeys.push({
        id: `${note}${octave}`,
        note,
        label: `${note}${octave}`,
        octave,
        type: "white",
      });
    });

    PIANO_BLACK_NOTES.forEach((note) => {
      const baseNote = note.replace("#", "");
      const whiteIndex = octaveOffset * PIANO_WHITE_NOTES.length + BLACK_KEY_AFTER_WHITE_INDEX[baseNote];
      blackKeys.push({
        id: `${note}${octave}`,
        note,
        label: `${note}${octave}`,
        octave,
        type: "black",
        leftPercent: ((whiteIndex + 0.78) / (PIANO_WHITE_NOTES.length * octaves)) * 100,
      });
    });
  }

  return {
    whiteKeys,
    blackKeys,
    whiteCount: whiteKeys.length,
  };
};
